import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { 
  GetPickForServiceCarListResponse, 
  GetServicesListResponse, 
  PostCarFaultRequest, 
  PostCarFaultResponse, 
  SetUnfinishedCarFaultsToRegisteredRequest, 
  SetUnfinishedCarFaultsToRegisteredResponse, 
  SetCarFaultInServiceRequest, 
  SetCarFaultInServiceResponse, 
  SetCarFaultFinishedRequest, 
  SetCarFaultFinishedResponse, 
  GetRegisteredCarFaultsRequest, 
  GetRegisteredCarFaultsResponse, 
  GetInServiceCarFaultsRequest, 
  GetInServiceCarFaultsResponse 
} from '../models/service.models';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getPickForServiceCarList(): Observable<GetPickForServiceCarListResponse> {
    return this.http.get<GetPickForServiceCarListResponse>(`${this.apiUrl}/Service/GetPickForServiceCarList`, { headers: this.getHeaders() });
  }

  getServicesList(): Observable<GetServicesListResponse> {
    return this.http.get<GetServicesListResponse>(`${this.apiUrl}/Service/GetServicesList`, { headers: this.getHeaders() });
  }

  postCarFault(request: PostCarFaultRequest): Observable<PostCarFaultResponse> {
    return this.http.post<PostCarFaultResponse>(`${this.apiUrl}/service/PostCarFault`, request, { headers: this.getHeaders() });
  }

  setUnfinishedCarFaultsToRegistered(request: SetUnfinishedCarFaultsToRegisteredRequest): Observable<SetUnfinishedCarFaultsToRegisteredResponse> {
    return this.http.post<SetUnfinishedCarFaultsToRegisteredResponse>(`${this.apiUrl}/service/SetUnfinishedCarFaultsToRegistered`, request, { headers: this.getHeaders() });
  }

  setCarFaultInService(request: SetCarFaultInServiceRequest): Observable<SetCarFaultInServiceResponse> {
    return this.http.post<SetCarFaultInServiceResponse>(`${this.apiUrl}/service/SetCarFaultInService`, request, { headers: this.getHeaders() });
  }

  setCarFaultFinished(request: SetCarFaultFinishedRequest): Observable<SetCarFaultFinishedResponse> {
    return this.http.post<SetCarFaultFinishedResponse>(`${this.apiUrl}/service/SetCarFaultFinished`, request, { headers: this.getHeaders() });
  }

  getRegisteredCarFaults(request: GetRegisteredCarFaultsRequest): Observable<GetRegisteredCarFaultsResponse> {
    return this.http.get<GetRegisteredCarFaultsResponse>(`${this.apiUrl}/Service/GetRegisteredCarFaults`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  getInServiceCarFaults(request: GetInServiceCarFaultsRequest): Observable<GetInServiceCarFaultsResponse> {
    return this.http.get<GetInServiceCarFaultsResponse>(`${this.apiUrl}/Service/GetInServiceCarFaults`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }
}